import { Controller, type ControllerProps, type FieldValues } from 'react-hook-form'
import type { JSX } from 'react'
import { Checkbox, type CheckboxProps } from 'settle-ui/components/Checkbox/Checkbox'

type Controller<T extends FieldValues> = Omit<ControllerProps<T>, 'render' | 'css'>
interface CheckboxControllerProps<T extends FieldValues> extends Controller<T>, CheckboxProps {}

export const CheckboxController = <T extends FieldValues>({
  name,
  rules,
  control,
  defaultValue,
  shouldUnregister,
  onChange,
  ...restCheckboxProps
}: CheckboxControllerProps<T>): JSX.Element => (
  <Controller
    name={name}
    rules={rules}
    control={control}
    defaultValue={defaultValue}
    shouldUnregister={shouldUnregister}
    render={({ field: { ref, value, ...fieldProps }, fieldState }) => (
      <Checkbox
        {...fieldProps}
        {...restCheckboxProps}
        onChange={(...args) => {
          fieldProps.onChange(...args)
          onChange?.(...args)
        }}
        inputRef={ref}
        value={value ?? false}
        error={Boolean(fieldState.error)}
      />
    )}
  />
)
